import React, { useState, useEffect, useContext, useRef } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { styled, alpha } from '@mui/material/styles';
// import { AppContext } from "AppContext";
import TableAllData from "components/Content/CustomTable/TableAllData";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, Grid, FormControl, Input, Badge } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import LoaderAnimation from "pages/LoaderAnimation";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import EmployeeBenefitsMenu from "components/Menu/EmployeeBenefitsMenu";
import EmployeeProfile from "area/employer/EmployeeCensus/EmployeeProfile";
import moment from "moment";
import { Utils } from "common/Utils";
import * as Yup from 'yup';
import AximTooltip from "components/AximTooltip";
import CensusPriorDataModal from "area/employer/EmployeeCensus/CensusPriorDataModal";
import CensusRehireEmployeeModal from "area/employer/EmployeeCensus/CensusRehireEmployeeModal";
import CensusChooseEmployeeModal from "area/employer/EmployeeCensus/CensusChooseEmployeeModal";

const formatSSN = (val) => "XXX-XX-" + val.replaceAll("-", "").slice(5);

function Census(props) {
  const { modalIsOpen, setModalIsOpen, companyId, setCompanyId } = useContext(PrivateRoutesContext);
  const [isActive, setActive] = useState(false);
  // const { oauthToken, setOauth } = useContext(AppContext);
  const [fetchedData, setFetchedData] = useState([]);
  const [dataEmpty, setDataEmpty] = useState(false);
  const [checkingData, setCheckingData] = useState(false);
  const [hwBenefitDate, setHwBenefitDate] = useState(null);
  const [currentCompany, setCurrentCompany] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const updateButtonOpen = Boolean(anchorEl);
  const [openUpdateButton, setOpenUpdateButton] = React.useState(false);
  const [openChooseEmployeesModal, setOpenChooseEmployeesModal] = React.useState(false);
  const [employeesNotInList, setEmployeesNotInList] = React.useState([]);
  const [openRehireEmployeesModal, setOpenRehireEmployeesModal] = React.useState(false);
  const [termedEmployees, setTermedEmployees] = React.useState([]);
  const [employeesToAdd, setEmployeesToAdd] = React.useState([]);
  const [employeesToRehire, setEmployeesToRehire] = React.useState([]);
  const [saving, setSaving] = React.useState(false);
  const [openPriorDataModal, setOpenPriorDataModal] = React.useState(false);
  const [priorData, setPriorData] = React.useState([]);
  const [dataFilter, setDataFilter] = React.useState(null);
  const [canSubmit, setCanSubmit] = React.useState(false);
  const [submitBadgeMessage, setSubmitBadgeMessage] = React.useState(null);
  const profileRef = useRef({});

  //List of Values
  const [states, setStates] = useState([]);
  const [employmentStatus, setEmploymentStatus] = useState([]);
  const [employeeGroups, setEmployeeGroups] = useState([]);
  const [maritalStatuses, setMaritalStatuses] = useState([]);
  const [genders, setGenders] = useState([]);

  const [censusManagementID, setCensusManagementID] = useState(null);
  const [censusManagementStatusID, setCensusManagementStatusID] = useState(130);
  const [modalTitle, setModalTitle] = useState();
  const [open, setOpen] = useState(false);
  const [profileErrors, setProfileErrors] = useState({});
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [openSubmitModal, setOpenSubmitModal] = useState(false);
  const [isLoadingCensus, setIsLoadingCensus] = useState(true);
  const emptyEmployee = {
    "Action": "New",
    "ChangeType": "New",
    "employeeID": "00000000-0000-0000-0000-000000000000",
    "companyID": "00000000-0000-0000-0000-000000000000",
    "insuredID": "00000000-0000-0000-0000-000000000000",
    "firstName": "",
    "lastName": "",
    "userName": null,
    "ssn": "",
    "emailAddress": null,
    "status": null,
    "contract": null,
    "classification": null,
    "serviceFee": 0,
    "dateCreated": "0001-01-01T00:00:00",
    "effectiveDateOfChange": "0001-01-01T00:00:00",
    "beginDate": "0001-01-01T00:00:00",
    "endDate": "0001-01-01T00:00:00",
    "changeDate": "0001-01-01T00:00:00",
    "prevBeginDate": "0001-01-01T00:00:00",
    "prevEndDate": "0001-01-01T00:00:00",
    "employeeGroupID": "00000000-0000-0000-0000-000000000000",
    "hourlySalary": 0,
    "weeklySalary": 0,
    "annualSalary": 0,
    "employeeAltKey": "NULL",
    "jobTitle": null,
    "locationCode": null,
    "hireDate": "",
    "rehireDate": "0001-01-01T00:00:00",
    "termDate": "",
    "serviceCreditDate": "0001-01-01T00:00:00",
    "employmentStatusID": 0,
    "employeeNotes": null,
    "location": null,
    "division": null,
    "department": null,
    "jobClass": null,
    "importFileID": "00000000-0000-0000-0000-000000000000",
    "employmentStatusName": null,
    "companyName": null,
    "companyCode": null,
    "jobsiteID": "00000000-0000-0000-0000-000000000000",
    "jobsiteName": null,
    "jobsiteCode": null,
    "payCalendarID": "00000000-0000-0000-0000-000000000000",
    "payCalendarName": null,
    "payCalendarCode": null,
    "benefitPackageID": "00000000-0000-0000-0000-000000000000",
    "benefitPackageName": null,
    "benefitPackageCode": null,
    "benefitClassID": "00000000-0000-0000-0000-000000000000",
    "benefitClassName": null,
    "benefitClassCode": null,
    "groupServiceFee": 0,
    "classServiceFee": 0,
    "effectiveDate": "0001-01-01T00:00:00",
    "birthDate": "",
    "email": "",
    "contractCode": null,
    "contractFringeRate": 0,
    "loginName": null,
    "employeeGroupCode": null,
    "isActiveConfigurationRow": true,
    "benefitEnrollments": [],
    "birthDateStr": "",
    "termDateStr": "",
    "hireDateStr": "",
    "genderID": 0,
    "maritalStatusID": 0,
    "mailingAddress1": null,
    "mailingAddress2": null,
    "mailingStateID": "00000000-0000-0000-0000-000000000000",
    "mailingCity": null,
    "mailingZipCode": null,
    "homePhone": null,
    "workPhone": null
  };

  const [newEmployeeProfileData, setNewEmployeeProfileData] = React.useState(emptyEmployee)
  const [columnsArray, setColumnsArray] = useState([]);

  // SET COLUMN TYPE
  const [columnType, setColumnType] = useState("");
  const [keyType, setKeyType] = useState(null);


  useEffect(() => {
    handleChangeCompany()
  }, [companyId]);

  useEffect(() => {
    fetchStates()
    fetchEmploymentStatus()
    fetchEmployeeGroups()
    fetchMaritalStatuses()
    fetchGenders()
  }, []);


  useEffect(() => {
    console.log('setting can submit')
    console.log(fetchedData.filter(e => e.Action !== undefined))
    setSubmitBadgeMessage(null)
    if(fetchedData.length > 0 && fetchedData.filter(e => e.Action !== undefined).length > 0){
      if(fetchedData.filter(e => e.Action == 'New' && (e.NewEmployment === undefined || e.NewEmployment == null)).length > 0){
        setSubmitBadgeMessage(fetchedData.filter(e => e.Action == 'New' && (e.NewEmployment === undefined || e.NewEmployment == null)).length)
      }
    }
    console.log((fetchedData.length > 0 && fetchedData.filter(e => e.Action !== undefined).length > 0 && fetchedData.filter(e => e.Action == 'New' && (e.NewEmployment === undefined || e.NewEmployment == null)).length == 0))
    setCanSubmit((fetchedData.length > 0 && fetchedData.filter(e => e.Action !== undefined).length > 0 && fetchedData.filter(e => e.Action == 'New' && (e.NewEmployment === undefined || e.NewEmployment == null)).length == 0))
  }, [fetchedData]);

  const uuid = () => {
    var chars = '0123456789abcdef'.split('');

    var uuid = [], rnd = Math.random, r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4'; // version 4

    for (var i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | rnd() * 16;

        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r & 0xf];
      }
    }

    return uuid.join('');
  }

  const fetchCostShares = () => {

  }
  const fetchStates = () => {
    apiGet(apiUrls.getStates()).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchStates");
        setStates(lovResponse.data)
      }
    )
  }

  const fetchEmploymentStatus = () => {
    apiGet(apiUrls.getEmploymentStatuses()).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchEmploymentStatus");
        setEmploymentStatus(lovResponse.data)
      }
    )
  }

  const fetchEmployeeGroups = () => {
    const selectedCompany = localStorage.getItem(`selectedCompanyId`);
    apiGet(apiUrls.getEmployeeGroups(selectedCompany)).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchEmployeeGroups");
        setEmployeeGroups(lovResponse.data)
      }
    )
  }

  const fetchMaritalStatuses = () => {
    apiGet(apiUrls.getMaritalStatuses()).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchMaritalStatuses");
        setMaritalStatuses(lovResponse.data)
      }
    )
  }

  const fetchGenders = () => {
    apiGet(apiUrls.getGenders()).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchGenders");
        setGenders(lovResponse.data)
      }
    )
  }

  const handleChooseEmployeesClose = () => {
    setOpenChooseEmployeesModal(false);
  }

  const handleRehireEmployee = () => {
    console.log('handleRehireEmployee');
    if (termedEmployees.length == 0) {
      const selectedCompany = localStorage.getItem(`selectedCompanyId`);
      apiGet(apiUrls.getTerminatedEmployees(selectedCompany)).then(
        (empResponse) => {
          let empData = empResponse.data.filter(emp => {
            return fetchedData.findIndex(d => d.insuredID == emp.insuredID) < 0;
          })
          setTermedEmployees(empData);
          console.log(empData, 'rehire employees');
          setOpenRehireEmployeesModal(true);
        }
      );
    }
    else {
      let empData = termedEmployees.filter(emp => {
        return fetchedData.findIndex(d => d.insuredID == emp.insuredID) < 0;
      })
      setTermedEmployees(empData);
      setOpenRehireEmployeesModal(true);
    }
  }


  const handleRehireEmployeesClose = () => {
    setOpenRehireEmployeesModal(false);
  }
  const handleChooseEmployee = () => {
    console.log('handleChooseEmployee');
    if (employeesNotInList.length == 0) {

      const selectedCompany = localStorage.getItem(`selectedCompanyId`);
      apiGet(apiUrls.getNotInComplianceEmployees(selectedCompany)).then(
        (empResponse) => {
          let empData = empResponse.data.filter(emp => {
            return fetchedData.findIndex(d => d.insuredID == emp.insuredID) < 0;
          })
          setEmployeesNotInList(empData);
          console.log(empData, 'choose employees');
          setOpenChooseEmployeesModal(true);
        }
      );
    }
    else {
      let empData = employeesNotInList.filter(emp => {
        return fetchedData.findIndex(d => d.insuredID == emp.insuredID) < 0;
      })
      setEmployeesNotInList(empData);
      setOpenChooseEmployeesModal(true);
    }
  }

  const handleSaveAddEmployee = () => {
    console.log(employeesToAdd, 'employeesToAdd');
    let empData = employeesNotInList.filter(emp => {
      return employeesToAdd.findIndex(d => d.insuredID == emp.insuredID) < 0;
    })

    setFetchedData([...fetchedData, ...employeesToAdd]);
    setEmployeesNotInList(empData);
    setEmployeesToAdd([]);
    setOpenChooseEmployeesModal(false);
  }

  const handleSaveRehireEmployee = () => {
    console.log(employeesToRehire, 'employeesToRehire');
    let empData = termedEmployees.filter(emp => {
      return employeesToRehire.findIndex(d => d.insuredID == emp.insuredID) < 0;
    })

    // console.log(empData,'empData')
    setFetchedData([...fetchedData, ...employeesToRehire]);

    setTermedEmployees(empData);
    setEmployeesToRehire([]);
    setOpenRehireEmployeesModal(false);
  }

  const handleClose = () => {
    setOpen(false);
  };
  const profileValidationSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required')
      .max(50, 'First Name must not exceed 50 characters'),
    lastName: Yup.string().required('Last Name is required')
      .max(50, 'Last Name must not exceed 50 characters'),
    ssn: Yup.string().required('SSN is required')
      .max(11, 'SSN must not exceed 10 characters')
      .required(),
    birthDate: Yup.date().min('1901-01-01').typeError('Birth date is required'),
    email: Yup.string().email().required(),
  });
  const handleProfileSave = (employeeId, newData) => {
    console.log('profile save ' + employeeId)
    if (newData.Action == 'New') {
      console.log('new profile')
      let objToMerge = { ...newData, ...{ NewProfile: newData } }
      let newFetchedData = [...fetchedData]
      newFetchedData.push(objToMerge)
      setFetchedData(newFetchedData);
      setOpenProfileModal(false)
    }
    else {
      let empIdx = fetchedData.findIndex(obj => obj.employeeID == employeeId);
      if (empIdx > -1) {
        if (!fetchedData[empIdx].original !== undefined) {
          fetchedData[empIdx]['original'] = copyToOriginal(fetchedData[empIdx]);
        }
      }
      let objToMerge = { ...newData, ...{ NewProfile: newData } }
      objToMerge['Action'] = 'Update';
      objToMerge['ChangeType'] = 'Change';
      console.log('objToMerge  ' + objToMerge)
      console.log(fetchedData.map((obj => obj.employeeID == employeeId ?
        { ...obj, ...objToMerge } : obj)))
      setFetchedData(fetchedData.map((obj => obj.employeeID == employeeId ?
        { ...obj, ...objToMerge } : obj)))
    }
  }


  const handleEmploymentSave = (employeeId, newData) => {
    console.log('employment edit ' + employeeId)

    if (newData.Action == 'New') {
      console.log('new')
      let objToMerge = { ...newData, ...{ NewEmployment: newData } }
      let newFetchedData = [...fetchedData]
      newFetchedData.push(objToMerge)
      setFetchedData(newFetchedData);
      setOpenProfileModal(false)
    }
    else {
      let empIdx = fetchedData.findIndex(obj => obj.employeeID == employeeId);
      if (empIdx > -1) {
        if (!fetchedData[empIdx].original !== undefined) {
          fetchedData[empIdx]['original'] = copyToOriginal(fetchedData[empIdx]);
        }
      }
      if (newData.termDate != "" && moment(newData.termDate).year() > 1900) {//0001-01-01T00:00:00
        newData.termDateStr = moment(newData.termDate).format("MM/DD/YYYY");
      }
      let objToMerge = { ...newData, ...{ NewEmployment: newData } }
      objToMerge['Action'] = 'Update';
      objToMerge['ChangeType'] = 'Change';
      if (fetchedData[empIdx]['original'].termDate != newData.termDate) {
        if (newData.termDate != "" && moment(newData.termDate).year() > 1900) {//0001-01-01T00:00:00
          objToMerge['ChangeType'] = 'Term';
        }
      }
      console.log('objToMerge  ' + objToMerge)
      console.log(fetchedData.map((obj => obj.employeeID == employeeId ?
        { ...obj, ...objToMerge } : obj)))
      setFetchedData(fetchedData.map((obj => obj.employeeID == employeeId ?
        { ...obj, ...objToMerge } : obj)))
    }
  }

  const handleBenefitSave = (employeeId, newData) => {
    console.log('benefit edit ' + employeeId)

    if (newData.Action == 'New') {
      console.log('new')
      let objToMerge = { ...newData, ...{ benefitEnrollments: newData } }
      let newFetchedData = [...fetchedData]
      newFetchedData.push(objToMerge)
      setFetchedData(newFetchedData);
      setOpenProfileModal(false)
    }
    else {

      let empIdx = fetchedData.findIndex(obj => obj.employeeID == employeeId);
      if (empIdx > -1) {
        if (!fetchedData[empIdx].original !== undefined) {
          fetchedData[empIdx]['original'] = copyToOriginal(fetchedData[empIdx]);
        }
      }
      let emp = fetchedData[empIdx];
      if (emp != null) {
        console.log(emp, 'org benefitEnrollments')
        let updatedBenefits = newData.filter(n => n.updated == true)
        console.log(updatedBenefits, 'updated benefit data')
        let benefitsToAdd = [];
        emp.benefitEnrollments = newData;
        if (emp['NewEnrollment'] == null) {
          emp['NewEnrollment'] = [];
        }

        for (let nb of updatedBenefits) {
          let bIdx = emp['NewEnrollment'].findIndex(n => n.benefitID == nb.benefitID);
          if (bIdx >= 0) {
            emp['NewEnrollment'][bIdx] = nb;
          }
          else {
            benefitsToAdd.push(nb);
          }
        }
        emp['NewEnrollment'] = [...emp['NewEnrollment'], ...benefitsToAdd];

        emp['Action'] = 'Update';
        emp['ChangeType'] = 'Change';
        console.log(emp, 'after benefitEnrollments')
      }
      console.log(fetchedData.map((obj => obj.employeeID == employeeId ?
        { ...obj, ...emp } : obj)))
      setFetchedData(fetchedData.map((obj => obj.employeeID == employeeId ?
        { ...obj, ...emp } : obj)))

    }
  }

  const handlePriorData = () => {
    const selectedCompany = localStorage.getItem(`selectedCompanyId`);
    apiGet(apiUrls.getPriorCensusManagement(selectedCompany))
      .then((response) => {
        console.log(response, 'prior census data')
        setOpenPriorDataModal(true);
        setPriorData(response.data)
      })
      .catch((e) => {
        console.log(e, "CATCHED handlePriorData");
      });
  }

  const handleAddEmployee = () => {
    const selectedCompany = localStorage.getItem(`selectedCompanyId`);
    let newEmpObj = { companyID: selectedCompany, employeeID: uuid(), insuredID: uuid(), Action: 'New' };
    setNewEmployeeProfileData({ ...emptyEmployee, ...newEmpObj });
    setProfileErrors({});
    setOpenProfileModal(true);
  }

  const copyToOriginal = (obj) => {
    let orgObj = { ...obj };
    if (orgObj.NewProfile !== undefined) {
      delete orgObj.NewProfile;
    }
    if (orgObj.NewEnrollment !== undefined) {
      delete orgObj.NewEnrollment;
    }
    if (orgObj.NewEnrollment !== undefined) {
      delete orgObj.NewEnrollment;
    }
    if (orgObj.Action !== undefined) {
      delete orgObj.Action;
    }
    if (orgObj.ChangeType !== undefined) {
      delete orgObj.ChangeType;
    }
    return orgObj;
  }

  const handleAddBenefitSave = (employeeId, benefitsToAdd,isNew = false) => {
    console.log(benefitsToAdd, 'benefits to add in census')

    let empIdx = fetchedData.findIndex(obj => obj.employeeID == employeeId);
    if (empIdx > -1) {
      if (!fetchedData[empIdx].original !== undefined) {
        fetchedData[empIdx]['original'] = copyToOriginal(fetchedData[empIdx]);
      }
    }
    let emp = fetchedData[empIdx];
    if (emp != null) {
      console.log(emp, 'org benefitEnrollments')
      if(!emp.benefitEnrollments){
        emp.benefitEnrollments = []  
      }
      emp.benefitEnrollments = [...emp.benefitEnrollments, ...benefitsToAdd];
      if (emp['NewEnrollment'] == null) {
        emp['NewEnrollment'] = [];
      }
      emp['NewEnrollment'] = [...emp['NewEnrollment'], ...benefitsToAdd];
      emp['Action'] = 'Update';
      emp['ChangeType'] = 'Change';
      console.log(emp, 'after benefitEnrollments')
    }
    console.log(fetchedData.map((obj => obj.employeeID == employeeId ?
      { ...obj, ...emp } : obj)))
    setFetchedData(fetchedData.map((obj => obj.employeeID == employeeId ?
      { ...obj, ...emp } : obj)))
  }
  const handleEmployeeReset = (employeeId) => {
    console.log('reset ' + employeeId)
    let empIdx = fetchedData.findIndex(obj => obj.employeeID == employeeId);
    console.log(fetchedData[empIdx], 'found ')
    if (empIdx > -1) {
      if (fetchedData[empIdx].original !== undefined) {
        let objToMerge = { ...fetchedData[empIdx].original };

        console.log(fetchedData[empIdx], 'reset to')
        setFetchedData(fetchedData.map((obj => obj.employeeID == employeeId ?
          objToMerge : obj)))
      }
    }
  }

  const handleSaveEmployeeProfile = async () => {
    console.log(profileRef, 'profileRef')
    if (profileRef != null && profileRef.current.formData !== undefined) {
      let formData = profileRef.current.formData;

      console.log(formData, 'handleSaveEmployeeProfile formData');
      const newProfile = {
        "employeeID": formData.employeeID,
        "birthDate": formData.birthDate,
        "email": formData.email,
        "firstName": formData.firstName,
        "genderID": formData.genderID,
        "insuredID": formData.insuredID,
        "lastName": formData.lastName,
        "mailingAddress1": formData.mailingAddress1,
        "mailingAddress2": formData.mailingAddress2,
        "mailingCity": formData.mailingCity,
        "mailingStateID": formData.mailingStateID,
        "mailingZipCode": formData.mailingZipCode,
        "maritalStatusID": formData.maritalStatusID,
        "middleName": formData.middleName,
        "ssn": formData.ssn,
        "workPhone": formData.workPhone,
        "homePhone": formData.homePhone,
        "Action": "New",
        "ChangeType": "New"
      };

      try {
        const valid = await profileValidationSchema.validateSync(newProfile,
          { abortEarly: false }
        );
        console.log(valid, 'valid')
        handleProfileSave(formData.employeeID, newProfile)

      } catch (error) {
        // error.inner
        console.log(error, 'valid error')
        let pErrors = {};
        for (const err of error.inner) {
          if (err.path) {
            console.log(err.path, 'err.path')
            console.log(err.message, 'err.message')
            Object.defineProperty(pErrors, err.path, {
              value: err.message,
              writable: true
            });
            //pErrors[error.path] = error.message;
          }
        }

        console.dir(pErrors, 'pErrors')
        setProfileErrors(pErrors)
      }
    }
  }

  const handleReset = () => {
    //reset from client?
    setFetchedData(fetchedData.filter(obj => (obj.Action === undefined || obj.Action == 'New')).map((obj) => {
      if (obj.original !== undefined) {
        console.log(obj, 'has original');
        return obj.original;
      }
      else {
        return obj;
      }
    }));
  }

  const handleProfileClose = () => {
    setOpenProfileModal(false);
  }

  const keysChangeCase = (j, toUpper = true) => {
    if (typeof j === 'string') { // so it works for javascript arrays as well
      try {
        j = JSON.parse(j);
      } catch (err) {
        console.error('Invalid JSON input');
        console.error(err);
      }
    }
    if (Array.isArray(j)) {
      console.log('is array?')
      if (j.length == 0) {
        return [];
      }
      return j.map(o => keysChangeCase(o, toUpper));
    }
    else {
      let newObj = Object.fromEntries(
        Object.entries(j).map(([k, v]) => [(toUpper ? k.charAt(0).toUpperCase() : k.charAt(0).toLowerCase()) + k.slice(1), v])
      );
      return newObj;
    }
  }

  const handleSave = (submitParse = false) => {
    setSaving(true)
    const selectedCompany = localStorage.getItem(`selectedCompanyId`);

    //convert property names to correct format before saving
    let updatedEmployees = fetchedData.filter(r => r.Action != null).map(ee => {
      if (ee.benefitEnrollments !== undefined) {
        console.log('yes BenefitEnrollments')
        console.log(keysChangeCase(ee.benefitEnrollments, true), 'yes BenefitEnrollments')

        ee.BenefitEnrollments = keysChangeCase(ee.benefitEnrollments, true);
      }
      if (ee.NewProfile !== undefined) {
        console.log('yes NewProfile')
        ee.NewProfile = keysChangeCase(ee.NewProfile, true);
      }

      if (ee.NewEmployment !== undefined) {
        console.log('yes NewEmployment')
        ee.NewEmployment = keysChangeCase(ee.NewEmployment, true);
      }

      if (ee.NewEnrollment !== undefined) {
        console.log('yes NewEnrollment')
        ee.NewEnrollment = keysChangeCase(ee.NewEnrollment, true);
      }
      ee = keysChangeCase(ee, true);
      return ee;
    })

    console.log(updatedEmployees, 'updatedEmployees');

    let censusData = {
      CompanyID: selectedCompany,
      HWBenefitDate: hwBenefitDate,
      CensusData: JSON.stringify(updatedEmployees.map(ee => keysChangeCase(ee, true)))
    };
    if (censusManagementID != null) {
      censusData.CensusManagementID = censusManagementID;
    }
    apiPost(apiUrls.postCensusManagement(selectedCompany), censusData)
      .then((response) => {
        console.log(response, 'census response')
        if (response.data != null && response.data.censusManagementID) {
          setCensusManagementID(response.data.censusManagementID)
          if (submitParse) {
            let censusData = {
              CompanyID: selectedCompany,
              CensusManagementID: response.data.censusManagementID
            }
            apiPost(apiUrls.parseCensusManagement(selectedCompany), censusData)
              .then((response) => {
                console.log(response, 'parse census response')
                setCensusManagementID(response.data.censusManagementID)
                setOpenSubmitModal(true)
                setTimeout(() => {
                  window.location.reload(false)
                }, 3000);
              })
              .catch((e) => {
                console.log(e, "CATCHED");
              })
              .finally(() => {
                setSaving(false);
              });
          }
        }
        else {
          setSaving(false);
        }

      })
      .catch((e) => {
        console.log(e, "CATCHED");
      })
      .finally(() => {
        setSaving(false);
      });;

  }

  const handleSaveSubmit = () => {
    handleSave(true)
  }


  const showBenefits = (benefits) => {
    return (<table>
      {
        Array.isArray(benefits) ?
          benefits.map((enrollment) => {
            return (<tr className="sub"><td className="sub"></td><td className="sub">{enrollment.benefit}</td><td className="sub">{(enrollment.benefit.toUpperCase().includes("WAIVE") ? ("" + ((benefits.length > 1) ? "\n" : "")) : " : " + enrollment.coverage + ((benefits.length > 1) ? "\n" : ""))}</td></tr>);
          }) : (<></>)
      }
    </table>);
  }

  const rowStyles = [
    {

    }
  ]

  const badgeProps = (action, changeType) => {
    // badgeContent={badgeContent(row.values.Action, row.values.ChangeType)}
    // invisible={badgeContent(row.values.Action, row.values.ChangeType)==""}>

    return {
      badgeContent: "Updated",
      invisible: true
    };
    /*
    if(changeType=="Change"){
      return {
        badgeContent: "Updated",
        invisible: true
      };
    }
    else if(changeType=="Term"){
      
      return {
        badgeContent: "Updated",
        invisible: true
      };

      return "Term";
    }
    else if(changeType=="Rehire"){
      return "Term";
    }
    if(action=="New"){
      return "New";
    }
    return "";
    */
  }

  const columns = [
    {
      Header: "InsuredID",
      accessor: "insuredID",
      disableFilters: true,
    },
    {
      Header: "benefitPackageID",
      accessor: "benefitPackageID",
      style: {
        display: "none"
      },
      cellStyle: {
        display: "none"
      },
      disableFilters: true,
    },
    {
      Header: "Action",
      accessor: "Action",
      style: {
        display: "none"
      },
      cellStyle: {
        display: "none"
      },
      disableFilters: true,
    },
    {
      Header: "ChangeType",
      accessor: "ChangeType",
      style: {
        display: "none"
      },
      cellStyle: {
        display: "none"
      },
      disableFilters: true,
    },
    {
      Header: "Action",
      accessor: "employeeID",
      Cell: ({ row }) => (
        <>
          <Box>
            <EmployeeBenefitsMenu employeeID={row.values.employeeID}
              insuredID={row.values.insuredID}
              benefitPackageID={row.values.benefitPackageID}
              hwBenefitDate={hwBenefitDate}
              handleProfileSave={handleProfileSave}
              handleEmploymentSave={handleEmploymentSave}
              handleBenefitSave={handleBenefitSave}
              handleEmployeeReset={handleEmployeeReset}
              handleAddBenefitSave={handleAddBenefitSave}
              states={states}
              employmentStatus={employmentStatus}
              employeeGroups={employeeGroups}
              maritalStatuses={maritalStatuses}
              genders={genders}
              employee={fetchedData.find((obj => obj.employeeID == row.values.employeeID))}
            />
          </Box>
        </>
      ),
      disableFilters: true,
    },
    {
      Header: "First Name",
      accessor: "firstName",
    },
    {
      Header: "Last Name",
      accessor: "lastName",
    },
    // {
    //   Header: "Email",
    //   accessor: "email",
    // },
    {
      Header: "SSN",
      accessor: "ssn",
      Cell: ({ row }) => (
        <Box >
          {formatSSN(row.values.ssn)}
        </Box>
      )
    },
    {
      Header: "Job Title",
      accessor: "jobTitle",
    },
    {
      Header: "DOB",
      accessor: (cell) => Utils.formatDate(cell.birthDateStr),
      Cell: ({ row }) => (
        <Box>
          {Utils.formatDate(row.original.birthDateStr)}
        </Box>
      ),
      sortType: "dateSort",
    },
    {
      Header: "DOH",
      accessor: (cell) => Utils.formatDate(cell.hireDateStr),
      Cell: ({ row }) => (
        <Box>
          {Utils.formatDate(row.original.hireDateStr)}
        </Box>
      ),
      sortType: "dateSort",
    },
    {
      Header: "Term Date",
      accessor: (cell) => Utils.formatDate(cell.termDateStr),
      Cell: ({ row }) => (
        <Box>
          {Utils.formatDate(row.original.termDateStr)}
        </Box>
      ),
      sortType: "dateSort",
    },
    // {
    //   Header: "Hourly Salary",
    //   accessor: "hourlySalary",
    // },
    {
      Header: "Benefits",
      accessor: "benefitEnrollments",
      //accessor: (cell) => < />,
      Cell: ({ row }) => (
        <Box >
          {showBenefits(row.values.benefitEnrollments)}
        </Box>
      )
    }
  ];

  const fetchCensusData = () => {
    const selectedCompany = localStorage.getItem(`selectedCompanyId`);
    setIsLoadingCensus(true);
    apiGet(apiUrls.getComplianceEmployees(selectedCompany)).then(
      (empResponse) => {
        let empData = empResponse.data;
        console.log(empData, "Census employee");
        apiGet(apiUrls.getCensus(selectedCompany)).then(
          (censusResponse) => {
            console.log(censusResponse, "Census data");
            let draftData = censusResponse.data;
            if (draftData.length == 0) {//no draft
              //get the next open payperiod
              console.log('no draft found');
              apiGet(apiUrls.getNextOpenPayperiod(selectedCompany)).then((ppResponse) => {
                console.dir(ppResponse, "pp response");
                console.dir(ppResponse.data.hwBenefitDate, " set hw benefit date")
                setHwBenefitDate(ppResponse.data.hwBenefitDate)
              })

              setCensusManagementID(null);
              setCensusManagementStatusID(130);
            }
            else {
              console.log(draftData, ' found draft');
              setCensusManagementID(draftData[0].censusManagementID);
              setHwBenefitDate(draftData[0].hwBenefitDate);
              setCensusManagementStatusID(draftData[0].statusID);
              let draftCensus = JSON.parse(draftData[0].censusData);
              console.log(draftCensus, ' censusData');
              for (let dc of draftCensus) {
                let empIdx = empData.findIndex(ed => ed.insuredID == dc.InsuredID);
                if (empIdx < 0) {
                    empData.push(keysChangeCase(dc, false))
                    empIdx = empData.findIndex(ed => ed.insuredID == dc.InsuredID);
                }
                if (empIdx >= 0) {
                  console.log('found ee')
                  //change key to first letter lower case
                  empData[empIdx] = keysChangeCase(dc, false)
                  if (dc.Action !== undefined) {
                    console.log('set action');
                    empData[empIdx].Action = dc.Action;
                  }
                  if (dc.ChangeType !== undefined) {
                    empData[empIdx].ChangeType = dc.ChangeType;
                  }

                  if (dc.NewProfile !== undefined) {
                    empData[empIdx].NewProfile = dc.NewProfile;
                  }
                  if (dc.NewEmployment !== undefined) {
                    empData[empIdx].NewEmployment = dc.NewEmployment;
                  }
                  if (dc.NewEnrollment !== undefined) {
                    empData[empIdx].NewEnrollment = dc.NewEnrollment;
                  }
                  if (dc.BenefitEnrollments !== undefined) {
                    empData[empIdx].benefitEnrollments = keysChangeCase(dc.BenefitEnrollments, false);
                  }
                }
              }
            }
            if (empData) {
              console.log("Set Fetch empdata");
              setFetchedData(empData);

            }
            setIsLoadingCensus(false);
            console.log(empData, "Census employee");
          }
        );


      }
    );
  }
  const handleChangeCompany = () => {
    const selectedCompany = localStorage.getItem(`selectedCompanyId`);
    setCurrentCompany(selectedCompany)
    if (selectedCompany != currentCompany) {
      fetchCensusData();
    }
  }
  const filterFetchedData = () => {
    console.log(dataFilter, 'filterFetchedData');
    if (dataFilter == null || dataFilter == "ALL") {
      return fetchedData;
    }
    else if (dataFilter == "New") {
      return fetchedData.filter(f => f.Action == "New");
    }
    else if (dataFilter == "Change") {
      return fetchedData.filter(f => f.ChangeType == "Change");
    }
    else if (dataFilter == "Term") {
      return fetchedData.filter(f => f.ChangeType == "Term");
    }
    else if (dataFilter == "Rehire") {
      return fetchedData.filter(f => f.ChangeType == "Rehire");
    }
    else if (dataFilter == "Update") {
      return fetchedData.filter(f => f.Action == "New" || f.Action == "Update");
    }
    return fetchedData;
  }

  const downloadFileError = (fileId) => {
    console.log(fileId, 'error fileId')

    apiGet(apiUrls.getDownloadImportErrors(fileId), { responseType: "blob" }).then(response => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "errors.csv");
      document.body.appendChild(link);
      link.click();

      console.log("File downloading successfully");
    }).catch(
      (response) => {

        console.error("File downloading successfully");
        //setErrorText("An Error occurred downloading the file.");
        //setDoShowError(true);
      }
    );

  }

  return (
    <>
      <div>
        <div className={`${ButtonStyle.buttonWrapper} ${ButtonStyle.uploadFileWrapper}`}>
          <div className="pull-left">
            <Button
              className={ButtonStyle.CsubmitBtn}
              variant="outlined"
              style={{ marginRight: "15px" }}
              onClick={handlePriorData}
            >
              Prior Data
            </Button>
            <Button
              variant="outlined"
              className={ButtonStyle.CsubmitBtn}
              style={{ marginRight: "15px" }}
              onClick={handleAddEmployee}
            >
              Add Employee
            </Button>
            <Button
              variant="outlined"
              className={ButtonStyle.CsubmitBtn}
              style={{ marginRight: "15px" }}
              onClick={handleChooseEmployee}
            >
              Choose Employees
            </Button>
            <Button
              variant="outlined"
              className={ButtonStyle.CsubmitBtn}
              style={{ marginRight: "15px" }}
              onClick={handleRehireEmployee}
            >
              Rehire Employees
            </Button>
            {/* <Button
              variant="outlined"
              className={ButtonStyle.CsubmitBtn}
              style={{ marginRight: "15px" }}
            >
              Rehire Employee
            </Button> */}
          </div>
          <div>

            <Button
              className={ButtonStyle.CsubmitBtn}
              variant="outlined"
              color="secondary"
              style={{ marginRight: "15px" }}
              onClick={handleReset}
            >
              Reset
            </Button>
            <Badge color="error"
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              badgeContent={submitBadgeMessage}>
              <LoadingButton
                className={ButtonStyle.CsubmitBtn}
                variant="outlined"
                color="secondary"
                style={{ marginRight: "15px" }}
                onClick={() => handleSave(true)}
                loading={saving}
                disabled={!canSubmit}
                loadingIndicator="Saving..."
              >
                Save & Submit
              </LoadingButton>
            </Badge>
            <LoadingButton
              className={ButtonStyle.CsubmitBtn}
              variant="outlined"
              color="secondary"
              style={{ marginRight: "15px" }}
              onClick={() => handleSave(false)}
              loading={saving}
              loadingIndicator="Saving..."
            >
              Save
            </LoadingButton>
          </div>
        </div>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <div>HW Benefit Date {moment(hwBenefitDate).format("MM/DD/YYYY")}</div>
          </Grid>
          <Grid item xs={1.2}>
            <div>New:<Button size="large" onClick={() => setDataFilter("New")}>{fetchedData.filter(f => f.Action == "New").length}</Button></div>
          </Grid>
          <Grid item xs={1.2}>
            <div>Rehire:<Button size="large" onClick={() => setDataFilter("Rehire")}>{fetchedData.filter(f => f.ChangeType == "Rehire").length}</Button></div>
          </Grid>
          <Grid item xs={1.2}>
            <div>Change:<Button size="large" onClick={() => setDataFilter("Change")}>{fetchedData.filter(f => f.ChangeType == "Change").length}</Button></div>
          </Grid>
          <Grid item xs={1.2}>
            <div>Term:<Button size="large" onClick={() => setDataFilter("Term")}>{fetchedData.filter(f => f.ChangeType == "Term").length}</Button></div>
          </Grid>
          <Grid item xs={1.2}>
            <div>Total:<Button size="large" onClick={() => setDataFilter("Update")}>{fetchedData.filter(f => f.Action == "New" || f.Action == "Update").length}</Button></div>
          </Grid>
          <Grid item xs={2}>
            <div>Total Employees:<Button size="large" onClick={() => setDataFilter(null)}>{fetchedData.length}</Button></div>
          </Grid>
        </Grid>
        {/* Census Table Data */}
        <div
          className={`${TableStyle.tableWrapper} ${TableStyle.InvoicesWrapper}`}
        >
          {isLoadingCensus ? (
            <LoaderAnimation />
          ) :
            (<TableAllData columns={columns} data={filterFetchedData()} rowStyles={rowStyles} />)}
        </div>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={TableStyle.invoicesDialog}
      >
        {/* {columnType === 'paymentCol' ? "Invoice Payments" : columnType === 'disbursementCol' ? "Disbursements" : columntType === 'creditCol' ? "Invoice Credits" : <></>} */}
        <DialogTitle id="alert-dialog-title">{"Invoice Payments"}</DialogTitle>
        <DialogContent>
          {checkingData ? (
            <LoaderAnimation />
          ) : dataEmpty ? (
            <h2>No Data</h2>
          ) : (
            <></>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <CensusChooseEmployeeModal
        openChooseEmployeesModal={openChooseEmployeesModal}
        handleChooseEmployeesClose={handleChooseEmployeesClose}
        employeesNotInList={employeesNotInList}
        setEmployeesNotInList={setEmployeesNotInList}
        employeesToAdd={employeesToAdd}
        setEmployeesToAdd={setEmployeesToAdd}
        handleSaveAddEmployee={handleSaveAddEmployee}
      />

      <CensusRehireEmployeeModal
        openRehireEmployeesModal={openRehireEmployeesModal}
        handleRehireEmployeesClose={handleRehireEmployeesClose}
        termedEmployees={termedEmployees}
        setTermedEmployees={setTermedEmployees}
        handleSaveRehireEmployee={handleSaveRehireEmployee}
        employeesToRehire={employeesToRehire}
        setEmployeesToRehire={setEmployeesToRehire}
      />

      <CensusPriorDataModal openPriorDataModal={openPriorDataModal}
        setOpenPriorDataModal={setOpenPriorDataModal}
        priorData={priorData}
      />

      <Dialog
        open={openProfileModal}
        onClose={handleProfileClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={ModalStyles.empDataModal}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          Add Employee
        </DialogTitle>
        <DialogContent className={ModalStyles.CustomTabsWrapper}>

          <form noValidate autoComplete="off" className="grid">
            <EmployeeProfile fetchedData={newEmployeeProfileData} ref={profileRef} states={states}
              maritalStatuses={maritalStatuses}
              genders={genders}
              errors={profileErrors}></EmployeeProfile>
          </form>
        </DialogContent>
        <DialogActions className={ButtonStyle.buttonWrapper}>
          <Button
            variant="outlined"
            onClick={handleSaveEmployeeProfile}
            className={ButtonStyle.CsubmitBtn}
          >
            Save
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            onClick={handleProfileClose}
            className={ButtonStyle.CcancelBtn}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSubmitModal}
        onClose={() => { setOpenSubmitModal(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Census management"}
        </DialogTitle>
        <DialogContent className={ModalStyles.CustomTabsWrapper}>
          Changes have been submitted to process.
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
    </>

  );
}

export default Census;
